import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "../../Assets/styles/customPhoneSelect.css";
import "react-phone-number-input/style.css";
import { ReactComponent as GenericAvatar } from "../../Assets/iconsv2/generic/GenericAvatar.svg";
import { useTranslate } from '@tolgee/react';
import PhoneInput from "react-phone-number-input";
import DeleteConfirmationChild from "../GenericComponents/DeleteConfirmationChild";
import PrimaryButtonRemove from "../GenericComponents/PrimaryButtonRemove";
import {
  displayAvatar,
  displayUserAvatar,
} from "../../Helpers/chatHelper/AvatarHelper";

const ChatDetailsView = ({
  conversationData,
  handleBlockContact,
  handleUnblockContact,
}) => {
  const profileAvatarRef = useRef();
  const [previewAvatar, setPreviewAvatar] = useState(
    conversationData.profile_picture
  );
  const [avatar, setAvatar] = useState(conversationData.profile_picture);
  const [name, setName] = useState(conversationData.name);
  const [about, setAbout] = useState(conversationData.about);
  const [phone, setPhone] = useState(conversationData?.phone_number);
  const [openUnblockModal, setOpenUnblockModal] = useState(false);
  const [openBlockModal, setOpenBlockModal] = useState(false);

  const handleAvatarChange = (e) => {
    setAvatar(e.target.files[0]);
    setPreviewAvatar(URL.createObjectURL(e.target.files[0]));
  };

  useEffect(() => { }, [conversationData]);
  const { t } = useTranslate();
  return (
    <AddNewGroupContainer>
      <Group>
        <TitleWrapper>
          <h1>{t('chat_details.user_details')}</h1>
        </TitleWrapper>

        <OptionWrapper>
          <ProfileDetails>
            <UserWrapper>
              <input
                type="file"
                hidden
                accept=".png, .jpg, .jpeg "
                ref={profileAvatarRef}
                onChange={(e) => handleAvatarChange(e)}
              />
              <UserAvatarWrapper>
                <UserAvatar>{displayUserAvatar(conversationData)}</UserAvatar>
              </UserAvatarWrapper>
              <CustomNameInput value={name} readOnly></CustomNameInput>
            </UserWrapper>
            {about && about.length > 1 && (
              <AboutWrapper>
                <CustomNameInput value={about} readOnly></CustomNameInput>
              </AboutWrapper>
            )}
          </ProfileDetails>
        </OptionWrapper>
      </Group>

      <Group>
        <TitleWrapper>
          <h1>{t('chat_details.account_details')}</h1>
        </TitleWrapper>
        <OptionWrapper>
          {conversationData.email &&
            <>
              <OptionLabel>
                <p>{t('profile.email')}</p>
              </OptionLabel>
              <AboutWrapper>
                <CustomInput
                  value={conversationData.email}
                  readOnly
                ></CustomInput>
              </AboutWrapper>
            </>
          }

          {conversationData.phone_number &&
            <>
              <OptionLabel>
                <p>{t('profile.phone_number')}</p>
              </OptionLabel>

              <PhoneNumberWrapper>
                <CustomPhoneWrapper>
                  <PhoneInput
                    readOnly
                    international
                    defaultCountry={"RO"}
                    name="phoneNumber"
                    placeholder={t('profile.phone_number')}
                    value={phone}
                    onChange={(e) => setPhone(e)}
                  />
                </CustomPhoneWrapper>
              </PhoneNumberWrapper>
            </>

          }

        </OptionWrapper>
      </Group>
      <Group>
        {conversationData.blocked ? (
          <DeleteConfirmationChild
            open={openUnblockModal}
            setOpen={setOpenUnblockModal}
            variant={"unblock_contact"}
            action={handleUnblockContact}
            item={conversationData}
          >
            <PrimaryButtonRemove
              style={{ padding: "16px" }}
              onClick={() => setOpenUnblockModal(true)}
              text={t('block_contacts.unblock').toUpperCase()}
            />
          </DeleteConfirmationChild>
        ) : (
          <DeleteConfirmationChild
            open={openBlockModal}
            setOpen={setOpenBlockModal}
            variant={"block_contact"}
            action={handleBlockContact}
            item={conversationData}
          >
            <PrimaryButtonRemove
              style={{ padding: "16px" }}
              onClick={() => setOpenBlockModal(true)}
              text={t('block_contacts.block')}
            />
          </DeleteConfirmationChild>
        )}
      </Group>
    </AddNewGroupContainer>
  );
};

export default ChatDetailsView;

const AddNewGroupContainer = styled.div`
  background: ${({ theme }) => theme.menu.background};

  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  gap: 25px;

  width: 100%;
  height: 100%;
  overflow: auto;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
    color: ${({ theme }) => theme.menu.infoText};
    font-size: 14px;
    font-weight: 900;
    line-height: 22px;
    text-transform: uppercase;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 16px;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;

`;

const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
  width:100%;
`;

const UserAvatar = styled.div`
  display: flex;
  cursor: pointer;
  height: 42px;
  width: 42px;
`;

const UserWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  h1 {
    font-size: 20px;
    font-weight: 500;
    line-height: 22px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
`;
const AboutWrapper = styled.div`
  display: flex;
  padding: 10px 0;
`;
const CustomInput = styled.input`
  width:100%;
  text-overflow:ellipsis;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.40799999237060547px;
  &:focus-visible {
    outline: none;
  }
`;

const CustomNameInput = styled(CustomInput)`
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  text-overflow:ellipsis;

`;

const UserAvatarWrapper = styled.div`
  position: relative;

`;

const PencilWrapper = styled.div`
  position: absolute;
  bottom: -5px;
  right: 0;
`;

const OptionLabel = styled.div`
  display: flex;
  justify-content: space-between;

  p {
    color: ${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
  }
`;
const CustomPhoneWrapper = styled.div`
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 100%;
  input {
    padding: 14px 16px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    background: ${({ theme }) => theme.menu.groupContentBackground};
    border-radius: 10px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
      outline: none;
    }
  }

  .PhoneInputCountry {
    border: none;
    background: ${({ theme }) => theme.menu.groupContentBackground};
    border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    align-self: center;
    margin-right: 0;
  }
  .PhoneInput {
    width: 100%;
  }
  .PhoneInputCountrySelectArrow {
    display: none;
  }
  .PhoneInputCountryIcon--border {
    box-shadow: none;
  }
  .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
    box-shadow: none;
  }
`;
const PhoneNumberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
